import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { Auth } from 'aws-amplify'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import axiosClient, { setAuthHeader } from 'services/axios-client'
import FormErrors from '../../FormErrors'
import { SignInContainer } from './style'

function LogIn(props) {
  const { t } = useTranslation()
  const history = useHistory()
  const { setAuthUser, setLoggedInUser, loginError } = useContext(DataContext)
  const [state, setState] = useState({
    username: '',
    password: '',
    errors: {
      cognito: null,
      blankfield: false,
    },
  })

  const clearErrorState = () => {
    setState({
      ...state,
      errors: {
        cognito: null,
        blankfield: false,
      },
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    clearErrorState()
    if (state.username.trim() === '' || state.password.trim() === '') {
      setState({
        ...state,
        errors: {
          ...state.errors,
          blankfield: true,
        },
      })

      return
    }

    try {
      const user = await Auth.signIn(state.username, state.password)
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        throw new Error('You are required to reset your password')
      }
      const session = await Auth.currentSession()

      const { data } = await axiosClient.post('/user/token', {
        cognitoID: user.attributes.sub,
        cognitoToken: session.getAccessToken().getJwtToken(),
      })
      setAuthHeader(data.token)

      axiosClient
        .get(`/users?cognito_id=${user.attributes.sub}`)
        .then(({ data }) => {
          setLoggedInUser(data)
        })
      setAuthUser(user.attributes)

      if (props.location.pathname === '/login') {
        const redirectItem = JSON.parse(localStorage.getItem('redirectItem'))
        if (redirectItem?.redirectUrl) {
          localStorage.setItem(
            'redirectItem',
            JSON.stringify({
              redirectUrl: null,
            }),
          )

          history.push(redirectItem.redirectUrl)
        }

        history.push('/dashboard')
      }
    } catch (error) {
      console.log(error)
      let err = null
      if (error.code === 'InvalidParameterException') {
        err = { message: t('login_error_occured') }
      } else {
        err = !error.message
          ? { message: t(error) }
          : { message: t(error.message) }
      }
      setState({
        ...state,
        errors: {
          ...state.errors,
          cognito: err,
        },
      })
    }
  }

  const onInputChange = (event) => {
    setState({ ...state, [event.target.id]: event.target.value })
    document.getElementById(event.target.id).classList.remove('is-danger')
  }

  return (
    <SignInContainer>
      <div className="signin-wrapper">
        <h4>{t('signin')}</h4>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <input
              className="input"
              type="text"
              id="username"
              aria-describedby="usernameHelp"
              placeholder={t('email')}
              value={state.username}
              onChange={onInputChange}
            />
          </div>
          <div className="field">
            <input
              className="input"
              type="password"
              id="password"
              placeholder={t('password')}
              value={state.password}
              onChange={onInputChange}
            />
          </div>
          {/* TODO: Combine errors. */}
          <FormErrors formerrors={loginError || state.errors} />{' '}
          <div className="field">
            <button className="btn btn-signin">{t('signin')}</button>
          </div>
        </form>
        {window.isEnabledSSO && (
          <>
            <div className="or">
              <div className="line" />
              <span>{t('or')}</span>
            </div>
            <div className="social">
              <button
                className="btn btn-facebook"
                onClick={() =>
                  Auth.federatedSignIn({
                    provider: CognitoHostedUIIdentityProvider.Facebook,
                    customState: 'login',
                  })
                }
              >
                <i className="fab fa-facebook-f"></i>{' '}
                {t('signin_with_facebook')}
              </button>
              <button
                className="btn btn-google"
                onClick={() =>
                  Auth.federatedSignIn({
                    provider: CognitoHostedUIIdentityProvider.Google,
                    customState: 'login',
                  })
                }
              >
                <i className="fab fa-google"></i> {t('signin_with_google')}
              </button>
            </div>
          </>
        )}
        <div className="forgot-password">
          <Link to="/forgot-password">{t('forgot_password?')}</Link>
        </div>
      </div>
    </SignInContainer>
  )
}

export default LogIn
